import { useState } from "react"
import Card from "react-bootstrap/Card"
import "../styles/EventCardBody.css"

/**
 * Article summary for front page. Contains a summary text and link to article.
 */
const EventCardBody = ({ event }) => {
    const [date, setDate] = useState(new Date(event.organizedOn))

    if( !event ) return <></>
    return (
        <Card.Body
            className="BREIKKI-event-card-body d-flex align-items-center justify-content-center p-0 "
        >
            <Card.Text className="BREIKKI-event-card-text">
                <span>{event.name} {date.getDate()}.{date.getMonth()+1}.</span>
            </Card.Text>
        </Card.Body>
    )
}


export default EventCardBody